import * as React from 'react'

export const footer = () => {
  return (
    <footer id="a11y-footer" className="footer">
      <div className="footer__inner">
        <div className="footer__top">
          <div className="footer__inner ls-container">
            <div className="footer__logo">
              <a href="/">
                <img loading="lazy" src="/frontend/images/sprites/logos.svg#white" alt={`${sitename}'s logo`} />
              </a>
            </div>
            <nav className="nav nav--footer">
              <ul className="nav__list text--s">
                <li className="nav__item">
                  <p className="nav__title title--s">
                  We are always looking for talented people
                  </p>
                </li>
                <li className="nav__item">
                  <a href="" className="nav__link deprecated-link--chevron">
                  Application Engineer in Rotterdam
                  </a>
                </li>
                <li className="nav__item">
                  <a href="" className="nav__link deprecated-link--chevron">
                  Project QHSE Manager in the Netherlands
                  </a>
                </li>
                <li className="nav__item">
                  <a href="" className="nav__link deprecated-link--chevron">
                  Workplanner Marine Works in Rotterdam
                  </a>
                </li>
                <li className="nav__item">
                  <a href="" className="nav__link deprecated-link--chevron">
                  More vacancies
                  </a>
                </li>
              </ul>
              <ul className="nav__list text--s">
                <li className="nav__item">
                  <p className="nav__title title--s">
                  Our expertise to help you achieve your goals
                  </p>
                </li>
                <li className="nav__item">
                  <a href="" className="nav__link deprecated-link--chevron">
                  Application Engineer in Rotterdam
                  </a>
                </li>
                <li className="nav__item">
                  <a href="" className="nav__link deprecated-link--chevron">
                  Project QHSE Manager in the Netherlands
                  </a>
                </li>
                <li className="nav__item">
                  <a href="" className="nav__link deprecated-link--chevron">
                  Workplanner Marine Works in Rotterdam
                  </a>
                </li>
                <li className="nav__item">
                  <a href="" className="nav__link deprecated-link--chevron">
                  More vacancies
                  </a>
                </li>
              </ul>
              <ul className="nav__list text--s">
                <li className="nav__item">
                  <p className="nav__title title--s">
                  Get to know more about Van Oord
                  </p>
                </li>
                <li className="nav__item">
                  <a href="" className="nav__link deprecated-link--chevron">
                  Application Engineer in Rotterdam
                  </a>
                </li>
                <li className="nav__item">
                  <a href="" className="nav__link deprecated-link--chevron">
                  Project QHSE Manager in the Netherlands
                  </a>
                </li>
                <li className="nav__item">
                  <a href="" className="nav__link deprecated-link--chevron">
                  Workplanner Marine Works in Rotterdam
                  </a>
                </li>
                <li className="nav__item">
                  <a href="" className="nav__link deprecated-link--chevron">
                  More vacancies
                  </a>
                </li>
              </ul>
            </nav>
          </div>
        </div>
        <div className="footer__bottom">
          <div className="footer__inner ls-container">
            <div className="footer__cta">
              <div className="footer__link text--s">
                <a className="deprecated-link--chevron">
                  Sign up now for our newsletter and magazine to always stay up-to-date
                </a>
              </div>
              <div className="footer__visual fit-object">
                <img loading="lazy" src="/frontend/images/footer-image.png"/>  
              </div>
            </div>
            <div className="footer__content">
              <div className="footer__social social">
                <ul className="social__list">
                  <li className="social__item">
                    <a  className="social__link social__link--linkedin"><svg aria-hidden="true" width="24" height="24"><use xlinkHref='#icon--linkedin' /></svg></a>
                  </li>
                  <li className="social__item">
                    <a  className="social__link social__link--facebook"><svg aria-hidden="true" width="24" height="24"><use xlinkHref='#icon--facebook' /></svg></a>
                  </li>
                  <li className="social__item">
                    <a  className="social__link social__link--instagram"><svg aria-hidden="true" width="24" height="24"><use xlinkHref='#icon--instagram' /></svg></a>
                  </li>
                  <li className="social__item">
                    <a  className="social__link social__link--youtube"><svg aria-hidden="true" width="24" height="24"><use xlinkHref='#icon--youtube' /></svg></a>
                  </li>
                  <li className="social__item">
                    <a  className="social__link social__link--vimeo"><svg aria-hidden="true" width="24" height="24"><use xlinkHref='#icon--vimeo' /></svg></a>
                  </li>
                </ul>
              </div>
              <nav className="nav nav--copyright">
                <ul className="nav__list text--s">
                  <li className="nav__item">
                    <a href="" className="nav__link">
                    Contact
                    </a>
                  </li>
                  <li className="nav__item">
                    <a href="" className="nav__link">
                    Privacy statement
                    </a>
                  </li>
                  <li className="nav__item">
                    <a href="" className="nav__link">
                    Cookie policy
                    </a>
                  </li>
                  <li className="nav__item">
                    <a href="" className="nav__link">
                    Purchasing condition
                    </a>
                  </li>
                </ul>
              </nav>
            </div>
          </div>
        </div>
      </div>
    </footer>
  )
}
